/** Common form schemas + status options for entity forms. */

export const STATO_OPTIONS = [
  { value: 'valido', label: 'Valido' },
  { value: 'in_scadenza', label: 'In scadenza' },
  { value: 'scaduto', label: 'Scaduto' },
];

export const WORKER_STATO_OPTIONS = [
  { value: 'attivo', label: 'Attivo' },
  { value: 'cessato', label: 'Cessato' },
];

export const CONTRACT_OPTIONS = [
  { value: '', label: '(vuoto)' },
  { value: '-', label: 'Nessuno' },
  { value: 'S', label: 'S — Solo Sicurezza' },
  { value: 'M', label: 'M — Solo Medicina del lavoro' },
  { value: 'S+M', label: 'S+M — Sicurezza + Medicina' },
  { value: 'RSPP', label: 'RSPP — Solo RSPP' },
  { value: 'HACCP', label: 'HACCP — Solo HACCP' },
  { value: 'AUTOGESTITA', label: 'AUTOGESTITA — Formazione gestita esternamente' },
  { value: 'SPOT', label: 'SPOT' },
];

export const SI_NO_OPTIONS = [
  { value: '', label: '(non valorizzato)' },
  { value: 'SI', label: 'SI' },
  { value: 'NO', label: 'NO' },
];

export const RISCHIO_OPTIONS = [
  { value: '', label: '(non valorizzato)' },
  { value: 'BASSO', label: 'Basso' },
  { value: 'MEDIO', label: 'Medio' },
  { value: 'ALTO', label: 'Alto' },
];

export const IDONEITA_OPTIONS = [
  { value: 'Idoneo', label: 'Idoneo' },
  { value: 'Idoneo con prescrizioni', label: 'Idoneo con prescrizioni' },
  { value: 'Idoneo con limitazioni', label: 'Idoneo con limitazioni' },
  { value: 'Non idoneo temporaneamente', label: 'Non idoneo temporaneamente' },
  { value: 'Non idoneo', label: 'Non idoneo' },
];

export const EVENT_TYPE_OPTIONS = [
  { value: 'formazione', label: 'Formazione' },
  { value: 'visita', label: 'Visita medica' },
  { value: 'dpi', label: 'DPI' },
  { value: 'haccp', label: 'HACCP' },
  { value: 'sicurezza', label: 'Sicurezza' },
  { value: 'scadenza', label: 'Scadenza generica' },
];

export const MACROSETTORI = [
  { value: 'ristorazione', label: 'Ristorazione' },
  { value: 'ricettivo', label: 'Ricettivo' },
  { value: 'artigiano', label: 'Artigiano' },
  { value: 'associazione', label: 'Associazione' },
  { value: 'metalmeccanico', label: 'Metalmeccanico' },
  { value: 'servizi', label: 'Servizi' },
  { value: 'commercio', label: 'Commercio' },
  { value: 'edilizia', label: 'Edilizia' },
  { value: 'agricoltura', label: 'Agricoltura' },
  { value: 'industria', label: 'Industria' },
  { value: 'sanita', label: 'Sanità' },
  { value: 'trasporti', label: 'Trasporti' },
  { value: 'altro', label: 'Altro' },
];

export const PROFILI_MARKETING = [
  { value: 'cibo_bevande', label: 'Preparazione/somministrazione cibi e bevande' },
  { value: 'haccp_obbligatorio', label: 'HACCP obbligatorio' },
  { value: 'rischio_alto', label: 'Rischio alto' },
  { value: 'rischio_medio', label: 'Rischio medio' },
  { value: 'rischio_basso', label: 'Rischio basso' },
  { value: 'rspp_esterno', label: 'RSPP esterno' },
  { value: 'medico_competente', label: 'Medico competente nominato' },
  { value: 'lavoratori_notturni', label: 'Lavoratori notturni' },
  { value: 'macchinari_pesanti', label: 'Uso macchinari pesanti' },
  { value: 'sostanze_pericolose', label: 'Sostanze pericolose' },
  { value: 'lavori_quota', label: 'Lavori in quota' },
];

export function companyFields(companies = []) {
  return [
    // ── Anagrafica ──
    { name: 'name', label: 'Denominazione', type: 'text', required: true, colSpan: 2 },
    { name: 'piva', label: 'Partita IVA', type: 'text' },
    { name: 'codiceFiscale', label: 'Codice fiscale', type: 'text' },
    { name: 'address', label: 'Indirizzo', type: 'text', colSpan: 2 },
    { name: 'codiceAteco', label: 'Codice ATECO', type: 'text' },
    { name: 'email', label: 'Email principale', type: 'email', placeholder: 'info@azienda.it' },
    { name: 'antincendio', label: 'Antincendio (livello)', type: 'text', placeholder: '1, 2, 3' },
    { name: 'primoSoccorso', label: 'Primo soccorso (gruppo)', type: 'text', placeholder: 'A, B/C' },
    { name: 'sede', label: 'Sede principale', type: 'text' },
    { name: 'dipendenti', label: 'N. dipendenti', type: 'number' },
    // ── Profilazione ──
    { name: 'sedi', label: 'Numero sedi', type: 'number' },
    { name: 'macrosettore', label: 'Macrosettore (da ATECO)', type: 'text', colSpan: 2 },
    { name: 'rischio', label: 'Rischio', type: 'select', options: RISCHIO_OPTIONS },
    { name: 'medicoCompetente', label: 'Medico competente', type: 'text' },
    { name: 'somministrazioneHACCP', label: 'Somministrazione HACCP', type: 'select', options: SI_NO_OPTIONS },
    { name: 'supportoHACCP', label: 'Supporto HACCP', type: 'select', options: SI_NO_OPTIONS },
    { name: 'rspp_csc', label: 'RSPP CSC', type: 'select', options: SI_NO_OPTIONS },
    { name: 'cpi', label: 'CPI', type: 'select', options: SI_NO_OPTIONS },
    { name: 'presenzaPiscine', label: 'Presenza piscine', type: 'select', options: SI_NO_OPTIONS },
    { name: 'legionella', label: 'Legionella', type: 'select', options: SI_NO_OPTIONS },
    { name: 'cantieri', label: 'Cantieri', type: 'select', options: SI_NO_OPTIONS },
    { name: 'respPiscine', label: 'Resp. Piscine', type: 'text' },
    { name: 'contratto', label: 'Contratto', type: 'select', options: CONTRACT_OPTIONS },
    // Legacy compat
    { name: 'over15Dipendenti', label: 'Oltre 15 dipendenti', type: 'checkbox', checkboxLabel: 'Sì, oltre 15 dipendenti' },
    { name: 'controlloVVF', label: 'Soggetta a controllo VVF', type: 'checkbox', checkboxLabel: 'Sì, soggetta a controllo Vigili del Fuoco' },
    { name: 'profili', label: 'Profilazione marketing (tag)', type: 'multiselect', options: PROFILI_MARKETING, colSpan: 2 },
    { name: 'note', label: 'Note', type: 'textarea', colSpan: 2 },
  ];
}

export function workerFields(companies = [], isClient = false, fixedCompanyId = null) {
  const f = [
    { name: 'firstName', label: 'Nome', type: 'text', required: true },
    { name: 'lastName', label: 'Cognome', type: 'text', required: true },
    { name: 'fiscalCode', label: 'Codice fiscale', type: 'text' },
    { name: 'birthDate', label: 'Data di nascita', type: 'date' },
    { name: 'birthPlace', label: 'Luogo di nascita', type: 'text' },
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      required: true,
      hidden: isClient || !!fixedCompanyId,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'mansione', label: 'Mansione', type: 'text' },
    { name: 'sede', label: 'Luogo di lavoro', type: 'text' },
    { name: 'contratto', label: 'Contratto', type: 'text' },
    { name: 'dataAssunzione', label: 'Data assunzione', type: 'date' },
    { name: 'stato', label: 'Stato', type: 'select', options: WORKER_STATO_OPTIONS },
  ];
  return f;
}

export function formazioneFields(workers = [], companies = [], isClient = false, fixedCompanyId = null) {
  return [
    { name: 'corso', label: 'Titolo corso', type: 'text', required: true, colSpan: 2 },
    {
      name: 'workerId',
      label: 'Lavoratore',
      type: 'select',
      options: workers.filter((w) => w.id).map((w) => ({ value: w.id, label: `${w.firstName} ${w.lastName}` })),
    },
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      required: true,
      hidden: isClient || !!fixedCompanyId,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'dataRilascio', label: 'Data rilascio', type: 'date' },
    { name: 'scadenza', label: 'Scadenza', type: 'date' },
    { name: 'durata', label: 'Durata (ore)', type: 'number' },
    { name: 'stato', label: 'Stato', type: 'select', options: STATO_OPTIONS },
  ];
}

export function visitaFields(workers = [], companies = [], isClient = false, fixedCompanyId = null) {
  return [
    {
      name: 'tipoVisita',
      label: 'Tipologia visita',
      type: 'select',
      colSpan: 2,
      options: [
        { value: 'Preventiva', label: 'Preventiva' },
        { value: 'Periodica', label: 'Periodica' },
        { value: 'Cambio mansione', label: 'Cambio mansione' },
        { value: 'Rientro malattia', label: 'Rientro malattia' },
        { value: 'Ripresa dopo infortunio', label: 'Ripresa dopo infortunio' },
        { value: 'Su richiesta del lavoratore', label: 'Su richiesta del lavoratore' },
        { value: 'Visita preassuntiva', label: 'Visita preassuntiva' },
      ],
    },
    {
      name: 'workerId',
      label: 'Lavoratore',
      type: 'select',
      options: workers.filter((w) => w.id).map((w) => ({ value: w.id, label: `${w.firstName} ${w.lastName}` })),
    },
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      required: true,
      hidden: isClient || !!fixedCompanyId,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'dataVisita', label: 'Data visita', type: 'date' },
    { name: 'scadenza', label: 'Prossima scadenza', type: 'date' },
    { name: 'medico', label: 'Medico competente', type: 'text' },
    { name: 'idoneita', label: 'Idoneità', type: 'select', options: IDONEITA_OPTIONS },
    {
      name: 'accertamenti',
      label: 'Accertamenti eseguiti',
      type: 'textarea',
      colSpan: 2,
      placeholder: 'Es. Spirometria; Audiometria; ECG; Saturazione; Screening visivo…',
      hint: 'Elenca gli accertamenti separati da ";" o virgole. Esempi: Spirometria, Audiometria, ECG, Saturazione, Etilometria, Emocromo, Es. Urine, Screening visivo (Visiotest), Controllo oculistico.',
    },
    { name: 'stato', label: 'Stato', type: 'select', options: STATO_OPTIONS },
  ];
}

export function dpiFields(workers = [], companies = [], isClient = false, fixedCompanyId = null) {
  return [
    { name: 'tipo', label: 'Tipo DPI', type: 'text', required: true, colSpan: 2 },
    {
      name: 'workerId',
      label: 'Lavoratore',
      type: 'select',
      options: workers.filter((w) => w.id).map((w) => ({ value: w.id, label: `${w.firstName} ${w.lastName}` })),
    },
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      required: true,
      hidden: isClient || !!fixedCompanyId,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'dataConsegna', label: 'Data consegna', type: 'date' },
    { name: 'scadenza', label: 'Scadenza', type: 'date' },
    { name: 'taglia', label: 'Taglia', type: 'text' },
  ];
}

export function haccpFields(companies = [], isClient = false) {
  return [
    { name: 'titolo', label: 'Titolo documento', type: 'text', required: true, colSpan: 2 },
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      required: true,
      hidden: isClient,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'responsabile', label: 'Responsabile', type: 'text' },
    { name: 'dataRilascio', label: 'Data rilascio', type: 'date' },
    { name: 'scadenza', label: 'Scadenza', type: 'date' },
    { name: 'stato', label: 'Stato', type: 'select', options: STATO_OPTIONS },
  ];
}

export function sicurezzaFields(companies = [], isClient = false) {
  return haccpFields(companies, isClient); // identical structure
}

export function calendarFields(companies = [], isClient = false) {
  return [
    { name: 'title', label: 'Titolo evento', type: 'text', required: true, colSpan: 2 },
    { name: 'date', label: 'Data', type: 'date', required: true },
    { name: 'type', label: 'Tipo', type: 'select', options: EVENT_TYPE_OPTIONS },
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      hidden: isClient,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'color', label: 'Colore (hex)', type: 'text', placeholder: '#023F80' },
  ];
}


export const SOPRALLUOGO_TIPI = [
  { value: 'sicurezza', label: 'Sicurezza' },
  { value: 'haccp', label: 'HACCP' },
  { value: 'piscine', label: 'Piscine' },
  { value: 'legionella', label: 'Legionella' },
  { value: 'antincendio', label: 'Antincendio' },
];

export function sopralluogoFields(companies = [], isClient = false, fixedCompanyId = null) {
  return [
    {
      name: 'companyId',
      label: 'Azienda',
      type: 'select',
      required: true,
      hidden: isClient || !!fixedCompanyId,
      options: companies.filter((c) => c.id).map((c) => ({ value: c.id, label: c.name })),
    },
    { name: 'tipi', label: 'Tipo di controllo (anche più di uno)', type: 'multiselect', required: true, options: SOPRALLUOGO_TIPI, colSpan: 2 },
    { name: 'lastDate', label: 'Ultimo sopralluogo', type: 'date' },
    { name: 'nextDate', label: 'Prossimo sopralluogo', type: 'date' },
    { name: 'alertEmail', label: 'Email per alert', type: 'email', placeholder: 'destinatario@azienda.it' },
    { name: 'alertDaysBefore', label: 'Giorni di preavviso', type: 'number', placeholder: '30' },
    { name: 'note', label: 'Note', type: 'textarea', colSpan: 2 },
  ];
}
